const ITEMS = [
  "Zero-Defect QA",
  "Enterprise IT Consulting",
  "Real-Time Observability",
  "Healthcare Software",
  "Cloud-Native Engineering",
  "Managed Infrastructure",
];

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-[0.28em] text-slate-400 sm:px-12">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-brand" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-slate-200/70 bg-slate-100/60 py-5"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
